// Educational materials (pomoce edukacyjne) for the shop and the dedicated page.
export const eduMaterials = [
  {
    slug: "kolorowanki-pakiet",
    lookup_key: "edu_kolorowanki",
    kind: "digital",
    title: "Kolorowanki Tonka i Duszka",
    subtitle: "12 stron do wydruku (PDF)",
    price_pln: 15,
    color: "#FDE68A",
    accent: "#F59E0B",
    icon: "palette",
    tagline: "Kredki gotowe? Duszek już czeka.",
    description:
      "Dwanaście czarno-białych ilustracji z Tonkiem, Duszkiem, Napoleonem i przyjaciółmi. Grubsze linie dla najmłodszych, cieńsze dla starszaków.",
    freebie_url: "/assets/tonek-cast.png",
    features: [
      "PDF w formacie A4",
      "Wydruk domowy — bez limitu",
      "Podgląd dostępny za darmo",
    ],
  },
  {
    slug: "karty-pracy",
    lookup_key: "edu_karty_pracy",
    kind: "digital",
    title: "Karty pracy — przedszkolak",
    subtitle: "24 karty ćwiczeniowe (PDF)",
    price_pln: 25,
    color: "#BAE6FD",
    accent: "#0EA5E9",
    icon: "book",
    tagline: "Trochę czytania, trochę liczenia, dużo rysowania.",
    description:
      "Litery, liczby, emocje, zagadki i labirynty. Karty zbudowane wokół historii Tonka — każde zadanie ma bohatera i mały cel.",
    freebie_url: null,
    features: [
      "24 karty A4",
      "Klucz odpowiedzi dla rodzica",
      "Odpowiada podstawie programowej dla 5–6 lat",
    ],
  },
  {
    slug: "audiobook-przygoda-u-babci",
    lookup_key: "edu_audiobook",
    kind: "digital",
    title: "Audiobook: Przygoda u Babci",
    subtitle: "42 minuty, głos lektorski",
    price_pln: 29,
    color: "#DDD6FE",
    accent: "#8B5CF6",
    icon: "headphones",
    tagline: "Do słuchania w aucie, przed snem, w wanience.",
    description:
      "Pełne nagranie pierwszego tomu w wykonaniu spokojnego, ciepłego lektora. Muzyka w tle, subtelne efekty dźwiękowe. Do pobrania w MP3.",
    freebie_url: null,
    features: [
      "MP3 · 42 min · 128 kbps",
      "Bezpłatna próbka 3 minuty",
      "Idealne przed snem",
    ],
  },
  {
    slug: "pakiet-startowy",
    lookup_key: "edu_pakiet_startowy",
    kind: "physical",
    title: "Pakiet Startowy",
    subtitle: "1 książka + kolorowanki + karty pracy",
    price_pln: 89,
    color: "#FECACA",
    accent: "#EF4444",
    icon: "gift",
    tagline: "Wszystko, czego trzeba, żeby zacząć.",
    description:
      "Papierowy pakiet z jedną książką (do wyboru), wydrukowanymi kolorowankami i kartami pracy. Oszczędzasz 25 zł względem osobnego kupowania.",
    freebie_url: null,
    features: [
      "1 książka w twardej oprawie",
      "Wydrukowane kolorowanki",
      "Zestaw kart pracy",
    ],
  },
];

// Free downloadable resources (no payment)
export const freeResources = [
  {
    slug: "kolorowanka-tonek",
    title: "Kolorowanka: Tonek pod chmurką",
    kind: "PDF",
    url: "/assets/char-tonek.png",
    description: "Jedna strona A4 do wydrukowania — na próbę.",
    icon: "palette",
  },
  {
    slug: "kolorowanka-duszek",
    title: "Kolorowanka: Duszek śpi",
    kind: "PDF",
    url: "/assets/char-duszek.png",
    description: "Duszek w krainie snów — idealna przed drzemką.",
    icon: "palette",
  },
  {
    slug: "audio-sample",
    title: "Audiobook: Fragment",
    kind: "MP3",
    url: "#",
    description: "3-minutowy fragment audiobooka — posłuchaj przed zakupem.",
    icon: "headphones",
  },
];

// Interactive quiz — 8 pytań o świecie Tonka i Duszka
export const quiz = [
  {
    q: "Kim jest Duszek?",
    options: ["Kotem Babci", "Najlepszym przyjacielem Tonka", "Pilotem samolotu", "Piratem"],
    correct: 1,
    hint: "Umie latać i znikać.",
  },
  {
    q: "Co Napoleon robi najlepiej?",
    options: ["Piecze ciasteczka", "Jest lojalnym towarzyszem", "Buduje wynalazki", "Śpi cały dzień"],
    correct: 1,
    hint: "Napoleon to Tosa Inu.",
  },
  {
    q: "Kto puścił latawiec-kometę?",
    options: ["Tonek", "Babcia", "Prof. Wincent", "Pirat Billy"],
    correct: 2,
    hint: "Wynalazca z wąsami.",
  },
  {
    q: "Czego chmura zapomniała robić w bajce „Chmura, która zapomniała padać”?",
    options: ["Kwitnąć", "Padać", "Fruwać", "Śpiewać"],
    correct: 1,
    hint: "Tytuł to podpowiedź.",
  },
  {
    q: "Co potrafi Duszek?",
    options: ["Piec pierogi", "Latać i znikać", "Prowadzić samochód", "Grać na skrzypcach"],
    correct: 1,
    hint: "Dwie superzdolności.",
  },
  {
    q: "Kim jest Robo-3000?",
    options: ["Kotem z przyszłości", "Robotem z przyszłości", "Piratem", "Wynalazkiem Babci"],
    correct: 1,
    hint: "Nazwa to podpowiedź.",
  },
  {
    q: "Gdzie mieszka Babcia w bajkach?",
    options: ["Nad morzem", "W dużym mieście", "W lesie", "W przytulnym domu z lampką"],
    correct: 3,
    hint: "Ma ciepłą lampkę.",
  },
  {
    q: "Co Duszek zawsze nosi w kieszeni?",
    options: ["Kluczyk", "Uśmiechy zapasowe", "Mapę", "Cukierki"],
    correct: 1,
    hint: "„Nigdy nie wychodził bez nich”.",
  },
];
